import React, { useState, useMemo, useEffect } from "react";
import {
  Drawer,
  Button,
  Typography,
  Collapse,
  message,
  Tabs,
  Spin,
  Tooltip,
} from "antd";
import {
  MinusOutlined,
  PlusOutlined,
  StarOutlined,
  DeleteOutlined,
  CloseOutlined,
  InboxOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import { axiosInstance } from "../utils/axiosInterceptor";
import { useSelector } from "react-redux";

const { Text } = Typography;
const { Panel } = Collapse;

const CartDrawer = ({
  visible,
  onClose,
  selectedProducts,
  setSelectedProducts,
  getCartData,
  getCatalogueDetails,
  pageSize,
  currentPage,
  getFavourite,
  faviouriteList,
  cartLoading,
  setCartloading,
  accountNo,
  supplierId,
  userId
}) => {
  const [favorites, setFavorites] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);
  const [activeTab, setActiveTab] = useState("cart");

  const { TabPane } = Tabs;

  const groupedProducts = useMemo(() => {
    return selectedProducts.reduce((acc, product) => {
      const supplier = product?.supplier_name || "AAFA";
      if (!acc[supplier]) acc[supplier] = [];
      acc[supplier].push(product);
      return acc;
    }, {});
  }, [selectedProducts]);

  const SavedProducts = useMemo(() => {
    return faviouriteList?.reduce((acc, product) => {
      const supplier = product?.supplier_name || "AAFA";
      if (!acc[supplier]) acc[supplier] = [];
      acc[supplier].push(product);
      return acc;
    }, {});
  }, [faviouriteList]);

  const totalCost = selectedProducts?.reduce(
    (sum, p) => sum + p.unit_price * p.quantity,
    0,
  );

  const totalSavings = 0;

  const handleQuantityChange = async (productCode, newQty, maxQty) => {
    if (newQty < 10) return;

    if (newQty > maxQty) return;

    setCartloading(true);
    const payload = {
      userId: userAuth?.id,
      product_code: productCode,
      quantity: newQty,
    };
    try {
      const response = await axiosInstance.post(
        "marketplace/cart/edit",
        payload,
         {
            headers : {
              "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
            }
          },
      );
      console.log(response, "response");
    } catch (error) {
      console.log(error, "error");
    } finally {
      setSelectedProducts((prev) =>
        prev.map((p) =>
          p.product_code === productCode ? { ...p, quantity: newQty } : p,
        ),
      );
      setCartloading(false);
    }
  };

  useEffect(() => {
    getFavourite();
    setActiveTab("cart");
  }, [visible]);

  const handleRemoveFromCart = async (productCode) => {
    setCartloading(true);
    const payload = {
      userId: userAuth?.id,
      product_code: productCode,
    };
    try {
      const response = await axiosInstance.post(
        "marketplace/cart/remove",
        payload,
         {
            headers : {
              "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
            }
          },
      );
      getCartData();
    } catch (error) {
      console.log(error, "Errrorr");
    } finally {
    }
  };

  const toggleFavorite = (productCode) => {
    setFavorites((prev) => ({
      ...prev,
      [productCode]: !prev[productCode],
    }));
  };

  const CustomPanelHeader = ({ supplier, products }) => (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-center gap-2">
        {/* <span className="text-blue-600">⊕</span> */}
        <Text strong>{supplier}</Text>
      </div>
      <Text type="secondary" className="text-sm">
        {products?.length} items
      </Text>
    </div>
  );
  const CheckOut = async () => {
    if(!accountNo || !supplierId || !userId){
      return;
    }
    setIsLoading(true);
    const payload = {
      userId: userAuth?.id,
      customer_name: userAuth?.first_name,
      customer_id:accountNo,
      party_id:supplierId,
      user_id:userId
    };
    try {
      const response = await axiosInstance.post(
        "marketplace/cart/checkout",
        payload,
         {
            headers : {
              "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
            }
          },
      );
      // console.log(response,"Reposneee")
      onClose();
      message.success(`${response?.data?.message} `);
      getCatalogueDetails(currentPage, pageSize);
    } catch (error) {
      console.log(error, "Error");
      message.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const addToFavourite = async (code) => {
    const payload = {
      userId: userAuth?.id,
      product_code: code,
    };
    setCartloading(true);
    try {
      const response = await axiosInstance.post(
        "marketplace/cart/save-for-later/add",
        payload,
         {
            headers : {
              "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
            }
          },
      );
      console.log(response, "Response");
      await getCartData();
      await getFavourite();
    } catch (error) {
      console.log(error, "Error");
    } finally {
      setCartloading(false);
    }
  };
  const NoProductsFound = () => {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <InboxOutlined className="text-4xl text-gray-400" />
        </div>

        <h3 className="text-lg font-semibold text-gray-700">
          No Products Found
        </h3>

        <p className="mt-2 text-sm text-gray-500 max-w-xs">
          There are no products to display at the moment.
        </p>
      </div>
    );
  };

  const movetoCart = async (code) => {
    if(!accountNo || !supplierId || !userId){
      return;
    }
    setCartloading(true);
    const payload = {
      userId: userAuth?.id,
      product_code: code,
      customer_id:accountNo,
      party_id:supplierId,
      user_id:userId
    };
    try {
      const response = await axiosInstance.post(
        "marketplace/cart/save-for-later/move-to-cart",
        payload,
         {
            headers : {
              "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
            }
          },
      );
      await getFavourite();
      await getCartData();
    } catch (error) {
      console.log(error, "Error");
    } finally {
      setCartloading(false);
    }
  };
  const handleRemoveFromFavourite = async (code) => {
    setCartloading(true);
    const payload = {
      userId: userAuth?.id,
      product_code: code,
    };
    try {
      const response = await axiosInstance.post(
        "marketplace/cart/save-for-later/remove",
        payload,
         {
            headers : {
              "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
            }
          },
      );
      await getFavourite();
    } catch (error) {
      console.log(error, "Error");
    } finally {
      setCartloading(false);
    }
  };

  return (
    <>
      <Drawer
        title={
          <div className="flex items-center justify-between p-2 border-none">
            <span className="text-[18px] font-bold text-[#0b1c4d]">
              Quick Cart
            </span>
            <div
              onClick={onClose}
              className="w-[30px] h-[30px] flex items-center justify-center rounded-lg bg-[#eef2ff] cursor-pointer hover:bg-[#e0e7ff]"
            >
              <CloseOutlined className="text-[#0b1c4d] text-[18px]" />
            </div>
          </div>
        }
        placement="right"
        onClose={onClose}
        closable={false}
        open={visible}
        width={400}
        bodyStyle={{ padding: 0 }}
        footer={
          activeTab === "cart" ? (
            selectedProducts?.length > 0 ? (
              <div className="relative">
                <div
                  className={`${
                    cartLoading ? "pointer-events-none blur-sm opacity-60" : ""
                  }`}
                >
                  <div className="px-4 py-3">
                    <div className="flex justify-between text-sm mb-2">
                      <Text type="secondary">Total savings</Text>
                      <Text type="primary">
                        ${" "}
                        {Number(totalSavings || 0).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Text>
                    </div>
                    <div className="flex justify-between mb-4">
                      <Text strong className="text-[20px] font-bold">
                        Total cost
                      </Text>
                      <Text strong className="text-[20px] font-bold">
                        ${" "}
                        {Number(totalCost || 0).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Text>
                    </div>
                    <Button
                      // type="primary"
                      block
                      // style={{
                      //   backgroundColor: "#4F46E5",
                      //   height: "40px",
                      //   color:"#fff"
                      // }}
                      className="!bg-[#001997] hover:!bg-[#061561] text-white border-none hover:!text-white disabled:!bg-[#001997] disabled:!text-white"
                      disabled={selectedProducts?.length === 0}
                      loading={isLoading}
                      onClick={() => CheckOut()}
                    >
                      Continue Purchasing
                    </Button>
                  </div>
                </div>
              </div>
            ) : null
          ) : null
        }
      >
        <div className="flex flex-col h-full">
          <div className="shrink-0 px-2 bg-white z-10">
            <Tabs
              activeKey={activeTab}
              onChange={(key) => setActiveTab(key)}
              className="custom-tabs w-full"
              centered={true}
            >
              <TabPane tab="Cart" key="cart" />
              <TabPane tab="Saved Products" key="saved" />
            </Tabs>
          </div>
          <div className="flex-1 overflow-y-auto">
            {activeTab === "cart" ? (
              selectedProducts?.length > 0 ? (
                <div className="relative">
                  <div
                    className={`${
                      cartLoading
                        ? "pointer-events-none blur-sm opacity-60"
                        : ""
                    }`}
                  >
                    {cartLoading && (
                      <div className="absolute inset-0 flex items-center justify-center z-50">
                        <Spin
                          size="large"
                          styles={{
                            indicator: {
                              color: "#722ed1",
                            },
                          }}
                        />
                      </div>
                    )}

                    <div className="flex flex-col mt-4 mb-4 ml-2 mr-2">
                      <Collapse
                        defaultActiveKey={Object.keys(groupedProducts)}
                        ghost
                        expandIconPosition="end"
                      >
                        {Object.entries(groupedProducts).map(
                          ([supplier, products]) => (
                            <Panel
                              key={supplier}
                              className="custom-collapse-panel"
                              header={
                                <CustomPanelHeader
                                  supplier={supplier}
                                  products={products}
                                />
                              }
                            >
                              {products?.map((product) => {
                                const qty = Number(product?.quantity ?? 0);
                                const availableQty = Number(
                                  product?.available_quantity ?? 0,
                                );
                                const isDisabled = qty >= availableQty;
                                return (
                                  <div
                                    key={product.product_code}
                                    className="mb-6 px-4"
                                  >
                                    <div className="flex justify-between items-center">
                                      <div>
                                        <Text
                                          className="block mb-1 text-[#222]"
                                          style={{
                                            fontSize: 14,
                                            fontWeight: "500",
                                          }}
                                        >
                                          {product?.product_name}
                                        </Text>
                                      </div>
                                      <div>
                                        <Tooltip title={"Move to Saved Products"}>
                                          <Button
                                            type="text"
                                            icon={
                                              <StarOutlined
                                                className={
                                                  favorites[
                                                    product?.product_code
                                                  ]
                                                    ? "text-yellow-400"
                                                    : "text-gray-400"
                                                }
                                              />
                                            }
                                            size="small"
                                            // onClick={() => toggleFavorite(product.product_code)}
                                            onClick={() =>
                                              addToFavourite(
                                                product?.product_code,
                                              )
                                            }
                                          />
                                        </Tooltip>
                                        <Tooltip title={"Remove From Cart"}>
                                          <Button
                                            type="text"
                                            icon={
                                              <DeleteOutlined className="text-red-600" />
                                            }
                                            size="small"
                                            onClick={() =>
                                              handleRemoveFromCart(
                                                product.product_code,
                                              )
                                            }
                                          />
                                        </Tooltip>
                                      </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                      {/* <div className="flex items-center gap-2 ">
                       <Button
                         icon={<MinusOutlined />}
                         size="small"
                         type="text"
                         style={{
                           border: "1px solid #d9d9d9",
                           padding: "0 4px",
                         }}
                        //  onClick={() =>
                        //    handleQuantityChange(
                        //      product.product_code,
                        //      product.quantity - 1
                        //    )
                        //  }
                       />
                       <span className="min-w-[2rem] text-center">
                         {product.quantity}
                       </span>
                       <Button
                         icon={<PlusOutlined />}
                         size="small"
                         type="text"
                         style={{
                           border: "1px solid #d9d9d9",
                           padding: "0 4px",
                         }}
                        //  onClick={() =>
                        //    handleQuantityChange(
                        //      product.product_code,
                        //      product.quantity + 1
                        //    )
                        //  }
                       />
                     </div> */}
                                      <div className="flex items-center border border-[#d0d7e2] rounded-[6px] overflow-hidden bg-white">
                                        <div
                                          onClick={() =>
                                            handleQuantityChange(
                                              product?.product_code,
                                              product?.quantity - 1,
                                              product?.available_quantity,
                                            )
                                          }
                                          className={`w-[36px] h-[32px] flex items-center justify-center select-none border-r border-[#d0d7e2] ${
                                            Number(product?.quantity) <= 10
                                              ? "cursor-not-allowed text-gray-400 bg-gray-100"
                                              : "cursor-pointer text-[#4a4a4a]"
                                          }`}
                                        >
                                          −
                                        </div>

                                        <div className="w-[44px] h-[32px] flex items-center justify-center border-r border-[#d0d7e2] text-[#4a4a4a] text-sm">
                                          {product?.quantity}
                                        </div>

                                        <div
                                          onClick={() =>
                                            handleQuantityChange(
                                              product?.product_code,
                                              product?.quantity + 1,
                                              product?.available_quantity,
                                            )
                                          }
                                          className={`w-[36px] h-[32px] flex items-center justify-center select-none text-[#4a4a4a]
                    ${
                      isDisabled
                        ? "cursor-not-allowed text-gray-400 bg-gray-100"
                        : "cursor-pointer text-[#4a4a4a]"
                    }`}
                                        >
                                          +
                                        </div>
                                      </div>

                                      <div className="flex items-center gap-3">
                                        <Text strong>
                                          ${" "}
                                          {Number(
                                            product?.unit_price *
                                              product?.quantity,
                                          ).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })}
                                          {/* $ {(product.unit_price * product.quantity).toFixed(2)} */}
                                        </Text>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </Panel>
                          ),
                        )}
                      </Collapse>
                    </div>
                  </div>
                </div>
              ) : (
                <NoProductsFound />
              )
            ) : faviouriteList?.length > 0 ? (
              <div className="relative">
                <div
                  className={`${
                    cartLoading ? "pointer-events-none blur-sm opacity-60" : ""
                  }`}
                >
                  {cartLoading && (
                    <div className="absolute inset-0 flex items-center justify-center z-50">
                      <Spin
                        size="large"
                        styles={{
                          indicator: {
                            color: "#722ed1",
                          },
                        }}
                      />
                    </div>
                  )}

                  <div className="flex flex-col mt-4 mb-4 ml-2 mr-2">
                    <Collapse
                      defaultActiveKey={Object.keys(SavedProducts)}
                      ghost
                      expandIconPosition="end"
                    >
                      {Object.entries(SavedProducts).map(
                        ([supplier, products]) => (
                          <Panel
                            key={supplier}
                            className="custom-collapse-panel"
                            header={
                              <CustomPanelHeader
                                supplier={supplier}
                                products={products}
                              />
                            }
                          >
                            {products?.map((product) => {
                              const qty = Number(product?.quantity ?? 0);
                              const availableQty = Number(
                                product?.available_quantity ?? 0,
                              );
                              const isDisabled = qty >= availableQty;
                              return (
                                <div
                                  key={product.product_code}
                                  className="mb-6 px-4"
                                >
                                  <div className="flex justify-between items-center">
                                    <div>
                                      <Text
                                        className="block mb-1 text-[#222]"
                                        style={{
                                          fontSize: 14,
                                          fontWeight: "500",
                                        }}
                                      >
                                        {product?.product_name}
                                      </Text>
                                    </div>
                                    <div>
                                      <Tooltip title={"Move to Cart"}>
                                        <Button
                                          type="text"
                                          icon={
                                            <UndoOutlined className="text-gray-500" />
                                          }
                                          size="small"
                                          onClick={() =>
                                            movetoCart(product.product_code)
                                          }
                                        />
                                      </Tooltip>
                                      <Tooltip
                                        title={"Remove from Save Products"}
                                      >
                                        <Button
                                          type="text"
                                          icon={
                                            <DeleteOutlined className="text-red-600" />
                                          }
                                          size="small"
                                          onClick={() =>
                                            handleRemoveFromFavourite(
                                              product.product_code,
                                            )
                                          }
                                        />
                                      </Tooltip>
                                    </div>
                                  </div>
                                  <div className="flex items-center justify-between">
                                    <div className="flex items-center border border-[#d0d7e2] rounded-[6px] overflow-hidden bg-white">
                                      <div className="w-[44px] h-[32px] flex items-center justify-center border-r border-[#d0d7e2] text-[#4a4a4a] text-sm">
                                        {product?.quantity}
                                      </div>
                                    </div>

                                    <div className="flex items-center gap-3">
                                      <Text strong>
                                        ${" "}
                                        {Number(
                                          product?.unit_price *
                                            product?.quantity,
                                        ).toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                        {/* $ {(product.unit_price * product.quantity).toFixed(2)} */}
                                      </Text>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </Panel>
                        ),
                      )}
                    </Collapse>
                  </div>
                </div>
              </div>
            ) : (
              <NoProductsFound />
            )}
          </div>
        </div>
      </Drawer>
      <style>
        {`
         .custom-collapse-panel > .ant-collapse-header {
          background: #f3f4f6 !important;
          border-radius: 8px;
          margin-bottom:8px;
        }
        `}
      </style>
    </>
  );
};

export default CartDrawer;